import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatDividerModule } from '@angular/material/divider';

interface FooterLink {
  label: string;
  href?: string;
  routerLink?: string;
}

interface FooterColumn {
  heading: string;
  links: FooterLink[];
}

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule, MatDividerModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  currentYear = new Date().getFullYear();

  columns: FooterColumn[] = [
    {
      heading: 'Product',
      links: [
        { label: 'Services', href: '/#features-section' },
        { label: 'Training & Events', routerLink: '/events' },
        { label: 'Register Your Hospital', routerLink: '/register-hospital' },
        { label: 'Sign In', routerLink: '/login' }
      ]
    },
    {
      heading: 'Company',
      links: [
        { label: 'About Us', routerLink: '/about' },
        { label: 'Contact Us', routerLink: '/contact' },
        { label: 'Events', routerLink: '/events' }
      ]
    },
    {
      heading: 'Legal',
      links: [
        { label: 'Privacy Policy', href: '#' },
        { label: 'Terms of Use', href: '#' }
      ]
    }
  ];

  socialLinks = [
    { label: 'Facebook', href: '#', icon: 'facebook' },
    { label: 'LinkedIn', href: '#', icon: 'linkedin' }
  ];
}
